<template>
  <div class="qty-wrapper">
    <div class="qty-fields">
      <SfQuantitySelector
        class="a-product-quantity"
        :qty="value"
        :value="value"
        :min="1"
        :max="maxQuantity"
        step="1"
        :disabled="disabled"
        @input="updateQuantity"
        @blur="$v.$touch()"
      />
      <span>
        <span class="qty-label">
          {{ basePriceLabel('vk_einheit') }}
        </span>
      </span>

      <span class="equals-symbol">=</span>

      <SfQuantitySelector
        class="a-product-quantity"
        :qty="baseValue"
        :value="baseValue"
        :min="1"
        :max="maxQuantity ? maxQuantity * product.baseprice_product_amount : ''"
        :disabled="disabled"
        @input="enterBaseQuantity"
        @blur="$v.$touch()"
      />
      <span class="base-price-label">{{ basePriceLabel('baseprice_product_unit') }}</span>
    </div>

    <div
      v-if="showOffcuts"
      class="qty-offcuts"
    >
        <SfCheckbox
          label="+10% Verschnitt"
          name="offcutscheckbox"
          v-model="offcuts"
          @change="updateOffcuts"
        />
    </div>
  </div>
</template>

<script>
import AProductQuantity from 'theme/components/atoms/a-product-quantity'
import { optionLabel } from '@vue-storefront/core/modules/catalog/helpers';
import { SfCheckbox } from '@storefront-ui/vue';

export default {
  name: 'AProductQuantityCalculator',
  mixins: [
    AProductQuantity
  ],
  components: {
    SfCheckbox
  },
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({})
    },
    value: {
      type: [Number, String],
      required: true,
      default: 1
    },
    maxQuantity: {
      type: Number,
      default: 1000
    },
    loading: {
      type: Boolean,
      default: false
    },
    unlimitQuantity: {
      type: Boolean,
      default: false
    },
    showOffcuts: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      baseValue: 1,
      offcuts: false,
      beforeOffcut: 0
    };
  },
  created () {
    this.updateQuantity(this.value)
  },
  methods: {
    updateOffcuts () {
      let value = this.baseValue
      if (this.offcuts) {
        this.beforeOffcut = value
        value = (value * 1.1).toFixed(3);
      } else {
        value = this.beforeOffcut
      }
      this.updateBaseQuantity(value)
    },
    resetOffcuts () {
      this.offcuts = false
    },
    enterBaseQuantity (value) {
      if ( this.showOffcuts ) {
        this.resetOffcuts()
      }
      this.updateBaseQuantity(value)
    },
    updateBaseQuantity (value) {
      const newValue = parseFloat(value)
      console.log(newValue)
      this.baseValue = !isNaN(newValue) ? newValue : 1

      if (!isNaN(newValue)) {
        this.value = Math.ceil(newValue / this.product.baseprice_product_amount)
        if (this.value === 0) {
          this.value = 1
        }
      } else {
        this.value = 1
      }
      this.$emit('input', this.value)
    },
    updateQuantity (value) {
      if ( this.showOffcuts ) {
        this.resetOffcuts()
      }
      const roundedValue = !isNaN(value) && value>1 ? Math.ceil(value) : 1
      this.value = ''
      this.$nextTick(() => {
        this.value = roundedValue
        this.baseValue = (roundedValue * this.product.baseprice_product_amount).toFixed(3)
        this.$emit('input', this.value)
      })
    },
    basePriceLabel (attr) {
      let product = this.product;
      if (this.$store.state.product.current.type_id === 'bundle') {
          product = this.$store.state.product.current
      }
      return optionLabel(
        this.$store.state.attribute,
        { attributeKey: attr, optionId: product[attr] }
      )
    }
  }
};
</script>
